import { Controller } from '@hotwired/stimulus'
import { differenceInCalendarDays, format, parseISO, subDays } from 'date-fns'

export default class extends Controller {
  static targets = [
    'startDate',
    'endDate',
    'powerPlant',
    'powerPlantName',
    'datePreset'
  ]
  static values = { maxDate: String }
  static outlets = ['kaia--date-range-picker-component']

  kaiaDateRangePickerComponentOutletConnected() {
    this.syncDatePreset()
  }

  applyDatePreset(event) {
    const days = Number(event.currentTarget.value)
    if (!days) return

    const endDate = parseISO(this.maxDateValue)
    this.kaiaDateRangePickerComponentOutlet.setDates(
      subDays(endDate, days - 1),
      endDate
    )
    this.syncDatePreset()
  }

  syncDatePreset() {
    if (!this.hasKaiaDateRangePickerComponentOutlet) return

    const [startDate, endDate] =
      this.kaiaDateRangePickerComponentOutlet.selectedDates
    const days =
      startDate && endDate
        ? differenceInCalendarDays(endDate, startDate) + 1
        : 0
    this.datePresetTarget.value =
      endDate &&
      format(endDate, 'yyyy-MM-dd') === this.maxDateValue &&
      [7, 30, 90].includes(days)
        ? String(days)
        : ''
  }

  selectPowerPlant(event) {
    this.powerPlantTarget.value = event.currentTarget.value
    this.powerPlantNameTarget.value = ''
    this.powerPlantNameTarget.dispatchEvent(new Event('input'))
    this.element.requestSubmit()
  }

  prepareSubmit(event) {
    const [startDate, endDate] =
      this.kaiaDateRangePickerComponentOutlet.selectedDates
    if (!startDate || !endDate) {
      event.preventDefault()
      return
    }

    this.startDateTarget.value = format(startDate, 'yyyy-MM-dd')
    this.endDateTarget.value = format(endDate, 'yyyy-MM-dd')
  }
}
